module.exports = __webpack_public_path__ + "static/assets/ff8465a1457e1b33bfe0e3b84c5e59f6.png";